// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetDigitalDonationReceiptFormDefinitionRequestViewModel from '../../viewModel/request/DigitalDonationReceipt/GetDigitalDonationReceiptFormDefinitionRequestViewModel';
import DigitalDonationReceiptFormDefinitionResourceViewModel from '../../viewModel/resource/DigitalDonationReceiptFormDefinitionResourceViewModel';
import PostDigitalDonationReceiptFormRequestViewModel from '../../viewModel/resource/PostDigitalDonationReceiptFormRequestViewModel';

export default (service: Servicelayer) => ({
  /**  */
  async getDigitalDonationReceiptFormDefinition(request: GetDigitalDonationReceiptFormDefinitionRequestViewModel, config?: RequestConfig) {
    const requestDTO = request.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-digital-donation-receipt-form-definition'] ?? 'core/DigitalDonationReceipt/Definition';
    const response = await service.get<any>(endpointPath, {
      query: {
        appSystemKey: requestDTO.appSystemKey,
        id: requestDTO.id,
        contactId: requestDTO.contactId,
      },
      ...config,
    });
    const dto = response.data.result;
    return new DigitalDonationReceiptFormDefinitionResourceViewModel().fromDTO(dto);
  },
  /**  */
  async postDigitalDonationReceiptForm(model: PostDigitalDonationReceiptFormRequestViewModel, config?: RequestConfig) {
    const modelDTO = model.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-post-digital-donation-receipt-form'] ?? 'core/DigitalDonationReceipt';
    const response = await service.post<any>(endpointPath, {
      body: modelDTO,
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return result as number | undefined;
  },
});
